import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HGSAgentType } from "src/app/constants/agent";
import { Genders } from "src/app/constants/genders";
import { MaskType } from "src/app/constants/masks";
import { TaxStaus } from "src/app/constants/tax-status";
import { USStates } from "src/app/constants/us-states";

@Component({
    selector: 'mwp-agent-sass-mat-controls',
    templateUrl: './sass-mat-controls.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SassMatControlsComponent implements OnInit {

    public matForm: FormGroup;
    public maskType = MaskType;
    public genders = Genders;
    public usStates = USStates;
    public hgsAgentType = HGSAgentType;
    public taxStatus = TaxStaus;

    constructor(
        private formBuilder: FormBuilder,
    ){
    }

    ngOnInit(): void {
      this.matForm = this.formBuilder.group({
            checkbox: [null],
            checkboxRequired: [true, Validators.required],
            checkboxDisabled: [{value: false, disabled: true}],
            checkboxDisabledRequired: [{value: true, disabled: true}, Validators.required],

            radio: [null],
            radioRequired: ["SUPERVISOR", Validators.required],
            radioDisabled: [{value: null, disabled: true}, Validators.required],
            radioSelectedDisabled: [{value: "SUPERUSER", disabled: true}, Validators.required],

            buttonToggle: [null],
            buttonToggleRequired: ["POST", Validators.required],
            buttonToggleDisabled: [{value: null, disabled: true}, Validators.required],
            buttonToggleSelectedDisabled: [{value: "PRE", disabled: true}, Validators.required],


            slideToggle: [null],
            slideToggleRequired: [true, Validators.required],
            slideToggleDisabled: [{value: true, disabled: true}, Validators.required],

            slideToggleAdd: [null],
            slideToggleRequiredAdd: [true, Validators.required],
            slideToggleDisabledAdd: [{value: false, disabled: true}, Validators.required],

            slideToggleTerm: [null],
            slideToggleRequiredTerm: [true, Validators.required],
            slideToggleDisabledTerm: [{value: true, disabled: true}, Validators.required],
        });  
    }

    
}